<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('configuration')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i
                    class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="clickSaveHandler">
                <i class="fa fa-floppy-o"></i>
                {{ $t('save') }}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <template v-for="ret in configs">
                        <div class="row" :key="ret.Code">
                            <div class="col-sm-3">
                                <div class="form-group">
                                    <label class="label-control blue">{{ret.Name}}</label>
                                    <div>
                                        <input v-if="ret.Type==1" class="form-control form-control-sm" type="text" v-model="ret.SettingValue"/>
                                        <template v-else-if="ret.Type==2">
                                            <select class="form-control form-control-sm" v-model="ret.SettingValue">
                                                <option v-for="ret in accounts" :key="ret.Id" :value="ret.Id">{{ret.Name}}</option>
                                            </select>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Swal from "sweetalert2";
    export default {
        data: function () {
            return {
                configs: [
                    {
                        Code: '100',
                        Name: this.$t('upload_path'),
                        SettingValue: '',
                        Type: 1
                    },
                    {
                        Code: '20000',
                        Name: 'Accounts Payable',
                        SettingValue: '',
                        Type: 2
                    },
                    {
                        Code: '11200',
                        Name: this.$t('stock_account_id'),
                        SettingValue: '',
                        Type: 2
                    },
                    {
                        Code: '14300',
                        Name: 'VAT Input',
                        SettingValue: '',
                        Type: 2
                    }
                ],
                codes: ['100', '20000','11200','14300'],
                accounts: []
            }
        },
        created() {
            let loading = this.$loading.show();
            this.accountList();
            this.$api().post('system/configurations', this.codes).then(res => {
                if (this.$isValid(res)) {
                    let records = res.data.Json.Configs;
                    this.configs.forEach(element => {
                        for(var i = 0;i<records.length;i++){
                            let item = records[i];
                            if(item.Code == element.Code){
                                element.SettingValue = item.SettingValue;
                                break;
                            }
                        }
                    });
                }
            }).finally(function () { loading.hide(); });
        },
        methods: {
            accountList: async function(){
                let res = await this.$api().post('Accounting/accounts', { Limit: 0 });
                if(this.$isValid(res)){
                    this.accounts = res.data.Data;
                }
            },
            clickSaveHandler: function () {
                let loading = this.$loading.show();
                this.$api().post('system/configuration/save', this.configs).then(res => {
                    if (this.$isValid(res)) {
                        Swal.fire('Success', 'The configuration save success.', 'success');
                    }
                }).finally(function () { loading.hide(); });
            }
        }
    }
</script>